// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Dictionary } from "@insite/client-framework/Common/Types";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { DataViewState, setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { AllEventsApiParameter, AllEventsModel, EventModel } from "@stanion/App/Services/AllEventsService";
import { Draft } from "immer";

interface AllEventsState extends DataViewState<EventModel> {
    readonly idByEventListNumber: Dictionary<string>;
}
const initialState: AllEventsState = {
    isLoading: {},
    idByEventListNumber: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};
const reducer = {
    "xLoadAllEvents/BeginLoadAllEvents": (
        draft: Draft<AllEventsState>,
        action: { parameter: AllEventsApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },
    "xLoadAllEvents/CompleteLoadAllEvents": (
        draft: Draft<AllEventsState>,
        action: { parameter: AllEventsApiParameter; collection: AllEventsModel },
    ) => {
        setDataViewLoaded(draft, action.parameter, action.collection, collection => collection?.events || []);
    },
};
const xAllEvents = createTypedReducerWithImmer(initialState, reducer);
(reducers as any).xAllEvents = xAllEvents;
export type xAllEvents = {
    xAllEvents: AllEventsState;
} & ApplicationState;
